import logo from './logo.svg';
import './App.css';
import React, { useState, Fragment } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation, Outlet } from "react-router-dom";
import Login from './screens/Login';
import Portal from './screens/Portal';
import LocalStore from './Storage/LocalStore';
import APIAdapter from './APIClient/APIAdapter';

function PrivateRoute(props) {
  // console.log("private route");
  // console.log(props);
  return props.isLoggedIn ? <Portal /> : <Navigate to="/login" replace/>;
}

export const AuthContext = React.createContext(this);

function App() {

  const [state, dispatch] = React.useReducer(
    (prevState, action) => {
      switch (action.type) {
        case 'SIGN_IN':
          return {
            ...prevState,
            isSignout: false,
            isLoggedIn: action.isLoggedIn,
          };
        case 'SIGN_OUT':
          return {
            ...prevState,
            isSignout: true,
            isLoggedIn: false,
          };
      }
    },
    {
      isLoading: true,
      isSignout: false,
      isLoggedIn: false
    }
  );

  React.useEffect(() => {
    // Fetch the token from storage then navigate to our appropriate place
    const bootstrapAsync = async () => {
      let isLoggedIn;
      let userData;
      try {
        isLoggedIn = await LocalStore.IsAuthenticated();
        // console.log(state);
        // console.log(isLoggedIn);
        if(isLoggedIn) {
            userData = await LocalStore.LoadData("UserData");
            userData = JSON.parse(userData);
            // console.log(userData);
            APIAdapter.authToken = userData.token;
            APIAdapter.refToken = userData.refToken;
            // APIAdapter.userId = userData.userId;
            // console.log(APIAdapter.authToken);
        }
      } catch (e) {
        // Restoring token failed
      }

      // After restoring token, we may need to validate it in production apps

      // This will switch to the App screen or Auth screen and this loading
      // screen will be unmounted and thrown away.
      dispatch({ type: 'SIGN_IN', isLoggedIn: isLoggedIn });
    };

    bootstrapAsync();
  }, []);

  const authContext = React.useMemo(
    () => ({
      signIn: async (isAuthenticated) => {
        // In a production app, we need to send some data (usually username, password) to server and get a token
        // We will also need to handle errors if sign in failed
        // After getting token, we need to persist the token using `SecureStore`
        // In the example, we'll use a dummy token

        dispatch({ type: 'SIGN_IN', isLoggedIn: isAuthenticated });
      },
      signOut: async () => {
        await LocalStore.SaveData("UserData", '');
        //dispatch({ type: 'RESTORE_TOKEN', isLoggedIn: false });
        dispatch({ type: 'SIGN_OUT' })
      }
    }),
    []
  );


  return (


    <AuthContext.Provider value={authContext}>

    <BrowserRouter>
      <Fragment>
      <Routes>

      <Route exact path='/' element={<PrivateRoute isLoggedIn={state.isLoggedIn} />}>
            <Route exact path='*' element={<Navigate to="/portal" />}/>
      </Route>

      <Route exact path='/login' element={state.isLoggedIn ? <Navigate to="/" /> : <Login/>}/>
      <Route exact path='/portal' element={state.isLoggedIn ? <Portal/> : <Navigate to="/" />}/>


      </Routes>
      </Fragment>
    </BrowserRouter>
    </AuthContext.Provider>
  );
}

export default App;
